
export default {
    namespaced:true,
    state: {
     /**是否切换成移动设备风格 */
    isPhoneStyle:false,
    showSlider:false,
    layout:'total, sizes, prev, pager, next, jumper'
    },
    mutations: {
     /**切换设备风格 */
     changePhoneStyle(state,value){
        state.isPhoneStyle=(value<=1200?true:false);
        state.showSlider=(value<=750?true:false);
        if(state.isPhoneStyle){
            state.layout='prev, pager, next';
        }else{
            state.layout='total, sizes, prev, pager, next, jumper';
        }
     }
    },
    getters:{
    },
    actions: {
       
    }
};